import styled from "styled-components";

const StyledPre = styled.pre`
  white-space: pre-wrap;
  padding: 12px;
  font-size: 12px;
`;

export default StyledPre;
